<script>
import compoment from '@/components/draggable/NewContent/NewCustomComponents/Radio/NewDRadioPreview'
export default {
  name: 'NewDSexPreview',
  extends: compoment
}
</script>
